import { DEFAULT_DISTANCE_FROM_CONTAINER } from "../constants.js";
const getIdealPositon = (distanceFromContainer = DEFAULT_DISTANCE_FROM_CONTAINER)=>`calc(100% + ${distanceFromContainer}px)`;
const overflowsLeft = (content)=>content.x < 0;
const overflowsRight = (content)=>content.x + content.width > window.innerWidth;
const overflowsTop = (content)=>content.y < 0;
const overflowsBottom = (content)=>content.y + content.height > window.innerHeight;
const adjustLaterallyIfNeeded = (contentRect)=>{
    if (overflowsLeft(contentRect)) return {
        left: '-5px',
        right: ''
    };
    if (overflowsRight(contentRect)) return {
        right: '-5px',
        left: ''
    };
    return {};
};
const adjustVerticallyIfNeeded = (content)=>{
    if (overflowsTop(content)) return {
        top: '0px',
        bottom: ''
    };
    if (overflowsBottom(content)) return {
        bottom: '0px',
        top: ''
    };
    return {};
};
const defaultPositionAdjustmentIfOverflowsVertically = (content, offset)=>{
    if (overflowsTop(content)) return {
        newPosition: 'bottom',
        top: getIdealPositon(offset),
        bottom: ''
    };
    if (overflowsBottom(content)) return {
        newPosition: 'top',
        bottom: getIdealPositon(offset),
        top: ''
    };
    return {};
};
const defaultPositionAdjustmentIfOverflowsHorizontally = (content, offset)=>{
    if (overflowsLeft(content) || overflowsRight(content)) return {
        newPosition: 'top',
        bottom: getIdealPositon(offset),
        left: '',
        right: ''
    };
    return {};
};
const getIdealBoundingRect = ({ container, content, position })=>{
    const yCenter = container.getBoundingClientRect().y + container.getBoundingClientRect().height / 2;
    const xCenter = container.getBoundingClientRect().x + container.getBoundingClientRect().width / 2;
    const { width, height } = content.getBoundingClientRect();
    let contentX;
    let contentY;
    contentX = 'top' === position || 'bottom' === position ? xCenter - width / 2 : 'left' === position ? container.getBoundingClientRect().x - width - 20 : container.getBoundingClientRect().x + container.getBoundingClientRect().width + 20;
    contentY = 'left' === position || 'right' === position ? yCenter - height / 2 : 'top' === position ? container.getBoundingClientRect().y - height - 20 : container.getBoundingClientRect().y + container.getBoundingClientRect().height + 20;
    return {
        x: contentX,
        y: contentY,
        width,
        height
    };
};
const isLateralPositionAndOverflowing = (position, rect)=>('left' === position || 'right' === position) && (overflowsRight(rect) || overflowsLeft(rect));
export { adjustLaterallyIfNeeded, adjustVerticallyIfNeeded, defaultPositionAdjustmentIfOverflowsHorizontally, defaultPositionAdjustmentIfOverflowsVertically, getIdealBoundingRect, getIdealPositon, isLateralPositionAndOverflowing };
